import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function formatCurrency(amount) {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
    }).format(amount);
}

export function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(date);
}

export function formatDateInput(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
}

export function downloadBlob(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}

export function getStatusLabel(status) {
    const labels = {
        draft: 'Brouillon',
        sent: 'Envoyé',
        accepted: 'Accepté',
        converted: 'Converti',
        pending: 'En attente',
        paid: 'Payé',
    };
    return labels[status] || status;
}

export function getCategoryLabel(category) {
    const labels = {
        sale: 'Salé',
        sucre: 'Sucré',
        boisson: 'Boisson',
    };
    return labels[category] || category;
}
